import {Space} from "antd";
import {
  StyledSessionDetailsDrawerBookingQuestionsItem,
  StyledSessionDetailsDrawerBookingDetailsHeader,
} from "./style";

export type SessionDetailsDrawerBookingQuestionsProps = {
  data: {
    question: string;
    answer?: string | null;
  }[];
};

export function SessionDetailsDrawerBookingQuestions({
  data,
}: SessionDetailsDrawerBookingQuestionsProps) {
  return (
    <div>
      {data.length > 0 && (
        <Space size={8} direction="vertical" style={{display: "flex"}}>
          <StyledSessionDetailsDrawerBookingDetailsHeader>
            Checkout form responses
          </StyledSessionDetailsDrawerBookingDetailsHeader>
          <div>
            <Space size={24} direction="vertical" style={{display: "flex"}}>
              {data.map((cr, index) => (
                <StyledSessionDetailsDrawerBookingQuestionsItem key={cr.question + index}>
                  <p className="bold-text">{cr.question}</p>
                  <p>
                    <span className="bold-text">Answer: </span>
                    <span>{cr.answer ?? "No answer"}</span>
                  </p>
                </StyledSessionDetailsDrawerBookingQuestionsItem>
              ))}
            </Space>
          </div>
        </Space>
      )}
    </div>
  );
}
